/**
 *
 * @param {"info"  | "danger"| "warning" | "success" } type
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
const Alert = ({ type, children }) => {
  return <div className={`alert alert-${type} mt-3`}>{children}</div>;
};

export default Alert;
